import React, { useEffect, useState } from "react"
import { QueueProps, } from "../../../../../context/FilaContext"
import { ClienteCard } from '../clienteCard'
import { verifyIcon } from "../../../../../utils/verifyIcons"
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ"
import { Loader } from "../../../../generics/loader"
import { apiModulo } from "../../../../../services/api"
import { useIsFetching, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { useAuth } from "../../../../../context/AuthContext"
import { useModal } from "../../../../../hooks/ModalContext"
import { format, subDays } from "date-fns"

interface FilaEsperaProps {
  id_channel?: number
}

export const FilaEspera = ({ id_channel }: FilaEsperaProps) => {
  const queryClient = useQueryClient()
  const [user, setUser] = useState<any>()
  const { cookies, decodedToken } = useAuth()
  const { setModal } = useModal()
  const dataAtual = new Date();
  const dataAnterior = subDays(dataAtual, 1);

  function decoded() {
    if (cookies?.token) {
      const userDecoded = decodedToken()
      setUser(userDecoded)
    }
  }
  useEffect(() => {
    decoded()
  }, [cookies?.token])


  const { data, refetch, isSuccess, isRefetching } = useQuery({
    queryKey: ['espera'], queryFn: async () => {
      const { data } = await apiModulo.get('/queues/1', { params: { filtro: id_channel || ' ', } })
      return data
    },
    enabled: true,
    refetchInterval: 35000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  },)

  const isFetching = useIsFetching()

  const isFetchingAtendimento = useIsFetching({ queryKey: ['atendimento'] })

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id_channel])

  const mutationTirarDaEspera = useMutation({
    mutationFn: (id_queue: string) => {
      return apiModulo.put(`/queues/waiting/${id_queue}/${user?.id_usuario}`)
    },
    onError: () => setModal('Limite de 10 atendimentos simultâneos atingido!', 'Erro', false, true)
  })

  async function mutateFilaEspera(id_queue: string) {
    await mutationTirarDaEspera.mutateAsync(id_queue)
    queryClient.refetchQueries({ queryKey: ['atendimento'] })
    refetch()
  }

  function mostrarFila() {
    return (isSuccess && data.queue?.length > 0) && data.queue.map((queue: QueueProps) => (
      <button className=" w-full text-left cursor-pointer" key={queue.id_queue} onDoubleClick={() => mutateFilaEspera(queue.id_queue)} disabled={isRefetching}>

        <ClienteCard
          nome={queue.name}
          status={2}
          cpf={formatCPFCNPJ(queue.cpf_cnpj)}
          hora_fila={queue.date_origin}
          icon={verifyIcon(queue.channel.channel === 'E-mail' ? 'email' : queue.channel.channel.toLocaleLowerCase())}
          text={
            "Callback"
          }
        />
      </button>
    ))

  }


  return (
    <div className="mb-2 overflow-y-auto pr-1 " >
      <div className="">
        {(isFetching || isFetchingAtendimento || !isSuccess) && (<div className=" flex justify-center items-center  min-h-[1.5rem]  ">
          {isRefetching && <p className="text-primary text-xs font-bold mr-3">Carregando</p>}
          <Loader />
        </div>)}
        {mostrarFila()}
      </div>
    </div>
  )
}

